module.exports = __webpack_public_path__ + "static/media/logout.4f67e569.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/logout.svg
// module id = 173
// module chunks = 0